import { render, staticRenderFns } from "./Crowded.vue?vue&type=template&id=a384f8ea&"
import script from "./Crowded.vue?vue&type=script&lang=js&"
export * from "./Crowded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports